import { type DotLottieReactProps } from '@lottiefiles/dotlottie-react'
import dynamic from 'next/dynamic'

const DotLottieReact = dynamic(
  () =>
    import('@lottiefiles/dotlottie-react').then((mod) => mod.DotLottieReact),
  { ssr: false }
)

const LottiePlayer: React.FC<DotLottieReactProps> = (props) => {
  return <DotLottieReact {...props} />
}

export default LottiePlayer
